import React, { useState } from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";

// material-ui icons
import Globales from "utils/Globales";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import "react-datepicker/dist/react-datepicker.css";
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';


class SeleccionarEmpresa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idIdioma: null,
            ListaAulas: [],
            ExtraAll:false,
            errorEmpresa: null
        };
        //Variable global para indicar el total de registros que se obtendra de la base de datos
        global.entrar = true;
    }

    componentDidMount() {
        if(this.props.ExtraAll != undefined){
            this.setState({ExtraAll:this.props.ExtraAll})
        }
        this.ListarAulas();
    }

    //Función para obtener las empresas
    ListarAulas() {
        fetch(Globales.Url + 'Alumnos/Alumnos/ListaGeneralAulas', {
            method: 'POST',
            headers: {
                Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
            }
        }
        ).then(res => res.json())
            .then(data => {
                if (data.error) { //Error en la respuesta
                    this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
                    this.showNotification();
                   } else { //Filtrado exitoso
                    //('Filtrado exitoso',data.data);
                    var ListaAulas = []
                    data.Aulas.map( idioma =>{
                      if(idioma.Consecutivo != "0" ){
                        ListaAulas.push(idioma)
                      }
                    })
                    this.setState({ ListaAulas:ListaAulas})
                  }
            })
            .catch(err => console.error(err));
    }
    
    idiomaSeleccionado = event => {
        // console.log("select;:",event.target.value._id)
        // this.setState({
        //     // razonSocial: event.target.value.RazonSocial,
        //     // idEmpresa: event.target.value._id
        //     idIdioma: event.target.value
        // });
        
        this.props.eventoClick(event.target.value)
    }

    render() {

        // var ListaEmpresas = [];
        // if (this.state.ListaEmpresas.length > 0) {
        //     ListaEmpresas = this.state.ListaEmpresas.map((d) => d.RazonSocial);
        // }

        const { classes } = this.props;
        return (
            <div>
                {/* <GridItem xs={12} sm={12} md={6} lg={6}> */}
                    <FormControl
                        fullWidth
                        style={{ width: "22em" }}
                        error={this.state.errorEmpresa}>
                        <InputLabel id="ILEmpresa">Aulas</InputLabel>
                        <Select
                            value={this.props.value}
                            onChange={this.idiomaSeleccionado}
                            name={this.state.razonSocial}
                            label={this.state.razonSocial}
                            labelId="ILEmpresa"
                            id="idEmpresa"                            
                            defaultValue={"Seleccione"}
                            inputProps={{
                                required: true,
                                error: this.state.errorEmpresa,
                                success: !this.state.errorEmpresa
                            }}
                        >
                        {this.state.ExtraAll == false ?
                            <MenuItem value={"null"} disabled={true}>Selecionar aula</MenuItem> 
                            : //else
                            <MenuItem value={"null"} >TODAS</MenuItem>
                        }
                        {this.state.ListaAulas.length == 0 ? null :
                            this.state.ListaAulas.map((idioma) => {
                                return (<MenuItem value={idioma._id} >{idioma.Nombre}</MenuItem>)
                            })}
                        </Select>
                    </FormControl>
                {/* </GridItem> */}
            </div>
        )
    }
}

export default withStyles(headerLinksStyle)(SeleccionarEmpresa);